<template>
  <div>
    <div v-if="loading" class="loading">
      <MoonLoader></MoonLoader>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-md-12">
          <CertificateProgress
            :current-internal-certificate="certificateProgress.current_certificate"
            :total_certification_score="certificateProgress.total_certification_score"
            :all_achieved_internal_certificates="certificateProgress.all_achieved_internal_certificates"
            :progress_to_next_certification="certificateProgress.progress_to_next_certification"
            :loading="loadCertificateProgress"
          >
          </CertificateProgress>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xl-3" v-for="stats in statsCards" :key="stats.title">
          <stats-card :loading="loadStats" chart-height="100%">
            <div class="icon-big text-center" :class="`icon-${stats.type}`" slot="header">
              <i :class="stats.icon"></i>
            </div>
            <div class="numbers" slot="content" v-if="isLargeScreen">
              <p>{{ stats.title.split(' ')[0] }}</p>
              <p>{{ stats.title.split(' ')[1] }}</p>
              {{ stats.value }}
            </div>
            <div class="numbers" slot="content" v-else>
              <p>{{ stats.title }}</p>
              {{ stats.value }}
            </div>
            <div class="stats" slot="footer">
              <div class="flex justify-content-between">
                <div><i :class="stats.footerIcon"></i> {{ stats.footerText }}</div>
                <div>
                  <div v-if="loadStats" :class="{ bgBlur: true }" style="height: 20%; width: 100%"></div>
                  <div v-if="stats.diffPrevMonth <= 0">
                    <i class="fas fa-caret-down caretUp text-danger"></i>
                    <span class="text-danger"> {{ stats.diffPrevMonth }} %</span>
                  </div>
                  <div v-else>
                    <i class="fas fa-caret-up caretUp text-primary"></i>
                    <span class="text-primary"> +{{ stats.diffPrevMonth }} %</span>
                  </div>
                </div>
              </div>
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3">
          <div class="flex">
            <div class="w-full">
              <DashboardElementTotal
                :loading="loadTotalPieChartData"
                :total="100"
                :progress="certificateProgress.total_certification_score"
                :questionnaireScoreByColor="questionnaireScoreByColor"
                infoText="Current weight of each unit in the certification"
              ></DashboardElementTotal>
            </div>
          </div>
        </div>
        <div class="col-xl-9">
          <div class="row mt-0">
            <div class="col-xl-12 pl-0 pr-0">
              <BarChartCard
                :loading="loadTotalProgress"
                :chartHeight="190"
                title="Total Progress"
                :chartData="chartData"
                :options="options"
                info-text="This card shows the club's past performance. The monthly stats calculate the club’s change in total score from the beginning of the month until the end of the month"
              />
            </div>

            <div class="col-xl-12 pl-0 pr-0">
              <LineChartCard
                :loading="loadTotalProgressForEachBlock"
                :chartHeight="190"
                title="Total Progress by each category"
                :chartData="LineChartData"
                :options="LineChartOptions"
                info-text="This card shows the club's past performance for each category"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UpperSidebar from '../components/SidebarPlugin/UpperSidebar';
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import DashboardElementSummary from '@/components/Dashboard/DashboardElementSummary';
import SummaryDashboardElementController from '@/controllers/DashboardElement/SummaryDashboardElementController';
import DashboardElementTotal from '@/components/Dashboard/DashboardElementTotal';
import DashboardElementRecommendations from '@/components/Dashboard/DashboardElementRecommendations';
import DashboardElementTotalProgress from '@/components/Dashboard/DashboardElementTotalProgress';
import ChartCard from '@/components/Cards/ChartCard';
import DashboardElementTotalProgressController from '@/controllers/DashboardElement/DashboardElementTotalProgressController';
import QuestionnaireScoreByColorController from '@/controllers/Question/QuestionnaireScoreByColorController';
import CertificateProgress from '@/components/Dashboard/CertificateProgress';
import TotalSuggestions from '@/components/Dashboard/TotalSuggestions';
import StatsCard from '@/components/Cards/StatsCard';
import DashboardStatsController from '@/controllers/DashboardElement/DashboardStatsController';
import DashboardCertificateProgressController from '@/controllers/DashboardElement/DashboardCertificateProgressController';
import TotalCertificationScoreProgressController from '@/controllers/Certificates/TotalCertificationScoreProgressController';
import TotalCertificationSummaryChartController from '@/controllers/DashboardElement/TotalCertificationSummaryChartController';
import BarChartCard from '@/components/Cards/BarChartCard';
import LineChartCard from '@/components/Cards/LineChartCard';
import TotalProgressForEachBlockController from '@/controllers/DashboardElement/TotalProgressForEachBlockController';
export default {
  components: {
    LineChartCard,
    BarChartCard,
    StatsCard,
    TotalSuggestions,
    CertificateProgress,
    ChartCard,
    DashboardElementTotalProgress,
    DashboardElementRecommendations,
    DashboardElementTotal,
    DashboardElementSummary,
    MoonLoader,
    UpperSidebar,
  },
  data() {
    return {
      summary: null,
      loading: false,
      questionType: null,
      totalProgressChart: {},
      questionnaireScoreByColor: {
        labels: ['Sustainability', 'Resiliency', 'Suggestions', 'Not achieved', 'Consumption'],
        series: [22.48, 11.99, 6, 42.02, 17],
      },
      loadStats: false,
      loadTotalPieChartData: false,
      activityChart: {
        data: {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          series: [[45, 32, 54, 65, 56, 66, 68, 70, 65, 73, 72, 70]],
        },
        options: {
          seriesBarDistance: 50,
          axisX: {
            showGrid: false,
          },
          height: '180px',
        },
      },
      totalPieChart: {
        data: {
          labels: ['62%', '32%', '9%'],
          series: [{ value: 62 }, { value: 32 }, { value: 9 }],
        },
        options: {},
      },
      statsCards: [
        {
          title: 'Suggestions Score',
          value: 160,
          icon: 'ti-light-bulb',
          type: 'success',
          footerIcon: 'ti-calendar',
          footerText: 'Current Month',
          secondFooterText: '',
          diffPrevMonth: 160,
        },
        {
          title: 'Sustainability Score',
          value: 19,
          icon: 'ti-clipboard',
          type: 'danger',
          footerIcon: 'ti-calendar',
          footerText: 'Current Month',
          secondFooterText: '',
          diffPrevMonth: -15.54,
        },
        {
          title: 'Resiliency Score',
          value: 70,
          icon: 'ti-pulse',
          type: 'success',
          footerIcon: 'ti-calendar',
          footerText: 'Current Month',
          secondFooterText: '',
          diffPrevMonth: 8.59,
        },
        {
          title: 'Consumption Score',
          value: 100,
          icon: 'fas fa-leaf',
          type: 'success',
          footerIcon: 'ti-calendar',
          footerText: 'Current Month',
          secondFooterText: '',
          diffPrevMonth: 0,
        },
      ],
      certificateProgress: {
        current_certificate: null,
        all_achieved_internal_certificates: [],
        total_certification_score: 0,
        progress_to_next_certification: 0,
      },
      chartData: {
        labels: [
          ['Jan', '12%'],
          ['Feb', '43%'],
          ['Mar', '+12%'],
          ['Apr', '+45%'],
          ['Mai', '+56%'],
          ['Jun', '+13%'],
          ['Jul', '+57.08%'],
          ['Aug', '-10%'],
          ['Sep', '-12%'],
          ['Oct', '+7%'],
          ['Nov', '+16%'],
          ['Dec', '+21%'],
          ['Total', '157.08%'],
        ],
        datasets: [
          {
            backgroundColor: this.getProgressChartColors([12, 43, 12, 45, 56, 13, 57.08, -10, -12, 7, 16, 21, null]),
            data: [12, 43, 12, 45, 56, 13, 57.08, -10, -12, 7, 16, 21, null],
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        barPercentage: 1.2,
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
          },
        },
        legend: {
          display: false,
        },
        animation: {
          onComplete: () => {
            this.delayed = true;
          },
          delay: (context) => {
            let delay = 0;
            if (context.type === 'data' && context.mode === 'default' && !this.delayed) {
              delay = context.dataIndex * 300 + context.datasetIndex * 100;
            }
            return delay;
          },
        },
      },
      LineChartData: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
          {
            label: 'Sustainability',
            fill: false,
            borderColor: '#73AB6B',
            backgroundColor: '#73AB6B',
            data: [42, 54, 34, 64, 55, 62, 56.2, 54, 34, 54, 23, 43], // sustainability
          },
          {
            label: 'Resiliency',
            fill: false,
            borderColor: '#F3BB44',
            backgroundColor: '#F3BB44',
            data: [12, 24, 54, 34, 54, 23, 43, 54, 57, 76, 87, 34], // resiliency
          },
          {
            label: 'Consumption',
            fill: false,
            borderColor: '#A4D1DE',
            backgroundColor: '#A4D1DE',
            data: [32, 43, 32, 12, 43, 80.7, 79.9, 12, 43, 43, 12, 32], // consumption
          },
          {
            label: 'Suggestions',
            fill: false,
            borderColor: '#EB5E28',
            backgroundColor: '#EB5E28',
            data: [43, 54, 65, 76, 56, 80.7, 79.9, 76, 56, 45, 65, 58], // suggestions
          },
        ],
      },
      LineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        barPercentage: 1.2,
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
          },
        },
        legend: {
          display: false,
        },
        animation: {
          onComplete: () => {
            this.delayed = true;
          },
          delay: (context) => {
            let delay = 0;
            if (context.type === 'data' && context.mode === 'default' && !this.delayed) {
              delay = context.dataIndex * 300 + context.datasetIndex * 100;
            }
            return delay;
          },
        },
      },
      loadCertificateProgress: false,
      loadTotalProgressForEachBlock: false,
      loadTotalProgress: false,
    };
  },
  computed: {
    isLargeScreen() {
      return window.innerWidth > 1199;
    },
  },
  created() {
    this.getDashboardStats();
    this.getCertificateProgress();
    this.getTotalProgressChart();
    this.getTotalPieChartData();
    this.getTotalProgressForEachBlock();
  },
  methods: {
    async getTotalProgressChart() {
      this.loadTotalProgress = true;
      let totalProgressChart = await TotalCertificationScoreProgressController.index();
      this.setTotalProgressChart(totalProgressChart);
      this.loadTotalProgress = false;
    },
    getProgressChartColors(totalProgressChart) {
      return totalProgressChart.map(function (element) {
        if (element > 0) return '#73AB6B';
        else return '#EB5E28';
      });
    },
    setTotalProgressChart(totalProgressChart) {
      this.totalProgressChart = totalProgressChart;
      let backgroundColorArray = this.getProgressChartColors(totalProgressChart.series[0]);
      this.chartData = {
        labels: totalProgressChart.labels,
        datasets: [
          {
            backgroundColor: backgroundColorArray,
            data: totalProgressChart.series[0],
          },
        ],
      };
      this.options = {
        responsive: true,
        maintainAspectRatio: false,
        barPercentage: 1.2,
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
          },
        },
        legend: {
          display: false,
        },
        animation: {
          onComplete: () => {
            this.delayed = true;
          },
          delay: (context) => {
            let delay = 0;
            if (context.type === 'data' && context.mode === 'default' && !this.delayed) {
              delay = context.dataIndex * 300 + context.datasetIndex * 100;
            }
            return delay;
          },
        },
      };
    },
    async getSignUpType() {
      let types = await this.$store.dispatch('retrieveQuestionTypes');
      return types.find((type) => {
        return type.name === 'SignUp';
      });
    },
    async getTotalPieChartData() {
      this.loadTotalPieChartData = true;
      try {
        this.questionnaireScoreByColor = await TotalCertificationSummaryChartController.index();
      } catch (e) {
        console.error(e);
      }
      this.loadTotalPieChartData = false;
    },
    async getDashboardStats() {
      this.loadStats = true;
      this.statsCards = await DashboardStatsController.index();
      this.loadStats = false;
    },
    async getCertificateProgress() {
      this.loadCertificateProgress = true;
      this.certificateProgress = await DashboardCertificateProgressController.index();
      this.loadCertificateProgress = false;
    },
    async getTotalProgressForEachBlock() {
      this.loadTotalProgressForEachBlock = true;
      let totalProgressForEachBlock = await TotalProgressForEachBlockController.index();

      this.LineChartData = {
        labels: totalProgressForEachBlock.labels,
        datasets: [
          {
            label: 'Sustainability',
            fill: false,
            borderColor: '#73AB6B',
            backgroundColor: '#73AB6B',
            data: totalProgressForEachBlock.series[0], // sustainability
          },
          {
            label: 'Resiliency',
            fill: false,
            borderColor: '#F3BB44',
            backgroundColor: '#F3BB44',
            data: totalProgressForEachBlock.series[1], // resiliency
          },
          {
            label: 'Consumption',
            fill: false,
            borderColor: '#A4D1DE',
            backgroundColor: '#A4D1DE',
            data: totalProgressForEachBlock.series[2], // consumption
          },
          {
            label: 'Suggestions',
            fill: false,
            borderColor: '#EB5E28',
            backgroundColor: '#EB5E28',
            data: totalProgressForEachBlock.series[3], // suggestions
          },
        ],
      };
      this.loadTotalProgressForEachBlock = false;
    },
  },
};
</script>
<style>
.caretUp {
  font-size: 1.5rem;
}
.row .flex .col-xl-12 {
  padding-left: 0;
  padding-right: 0;
}
.ct-series-a .ct-bar {
  /* Set the colour of this series line */
  stroke: #73ab6b !important;
  stroke-width: 10rem;
}
.ct-series-b .ct-bar {
  /* Set the colour of this series line */
  stroke: #ff6a6a !important;
  stroke-width: 10rem;
}
</style>
